import MoreInfoItem from "./MoreInfoItem";
import { v4 as ukey } from "uuid"
import "./style.css"
import { moreInfoData } from "./MoreInfoItem/MoreInfoData";
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { useContext } from "react";
import WindowSizeContext from "../../utils/WindowSizeContext"


const MoreInfo = (props) => {

    const moreInfoItems = moreInfoData.map(item => {
        return (<MoreInfoItem key={ukey()} moreInfoData={item} />);
    })

    const size = useContext(WindowSizeContext);

    return <>
        <div className="more-info-container">
            <div className="more-info-header">
                <p className="header-text">Подробности</p>
            </div>
            <div className='gallery-panel-for-top'>
                <div className='gallery-panel-top'>
                    {moreInfoItems}
                    {/* {size.width <= 428 ?
                        <AliceCarousel
                            activeIndex={1}
                            autoHeight={false}
                            autoWidth={false}
                            mouseTracking={true}
                            controlsStrategy="responsive"
                            disableButtonsControls={true}
                            disableDotsControls={true}
                            responsive={{ 0: { items: 1.15 } }}
                            items={moreInfoItems} />
                        : moreInfoItems
                    } */}
                </div>
            </div>
        </div>
    </>
}

export default MoreInfo;